import { Component, input, output } from '@angular/core';
import {
  CrntButton,
  CrntIcon,
  CrntIconButton,
  CrntVisuallyHidden,
} from '@essent/current-web-angular';
import { AutomationIdDirective } from '@innogy/utils-automation-id';

@Component({
  selector: 'wl-navigation-help-needed-button',
  standalone: true,
  imports: [
    CrntButton,
    CrntIconButton,
    CrntIcon,
    CrntVisuallyHidden,
    AutomationIdDirective,
  ],
  templateUrl: './navigation-help-needed-button.component.html',
})
export class NavigationHelpNeededButtonComponent {
  readonly text = input.required<string>();
  clicked = output();
}
